import React from 'react';
import {useLocation} from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

type ErrorBoundaryProviderProps = {
	children: React.ReactNode;
};

const ErrorBoundaryProvider: React.FC<ErrorBoundaryProviderProps> = ({children}) => {
	const location = useLocation();

	return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryProvider;
